import { useTranslation } from "react-i18next";

import { ExecutionStatus } from "../model/types";
import { StatusChip, StatusChipVariant } from "./StatusChip";

type ExecutionStatusChipProps = {
  className?: string;
  status: ExecutionStatus;
};

const variantMapping: Record<ExecutionStatus, StatusChipVariant> = {
  completed: "success",
  done: "success",
  error: "error",
  failed: "error",
  pending: "neutral",
  processing: "info",
  queued: "neutral",
  running: "info",
  waiting: "neutral",
};

export const ExecutionStatusChip = ({ className, status }: ExecutionStatusChipProps) => {
  const { t } = useTranslation();

  return (
    <StatusChip className={className} variant={variantMapping[status]}>
      {t(`general.${status}`)}
    </StatusChip>
  );
};
